import { PercentageCell } from "app/components/React/Table/cells";
import { PercentPointCell } from "app/components/React/Table/cells/PercentPointCell";
import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { translate } from "app/filters/i18nFilter";
import { DataWithChartColorCell } from "app/pages/activation/components/DataWithChartColorCell/DataWithChartColorCell";

import { BenchmarkGranularity } from "../../types/common";

import { textKeys } from "./texts";

export const getColumns = (granularity: BenchmarkGranularity) =>
    Object.seal([
        {
            field: "domain",
            visible: true,
            sortDirection: "desc",
            sortable: false,
            showTotalCount: false,
            width: "50%",
            disableHeaderCellHover: true,
            headerComponent: DefaultCellHeader,
            displayName: translate(textKeys.domain),
            isResizable: false,
            cellComponent: DataWithChartColorCell,
        },
        {
            field: "trafficShare",
            sortable: false,
            visible: true,
            disableHeaderCellHover: true,
            headerComponent: DefaultCellHeaderRightAlign,
            displayName: translate(textKeys.trafficShare),
            width: "27%",
            maxWidth: 60,
            sortDirection: "asc",
            isResizable: false,
            cellComponent: (props: ITableCellProps) => (
                <PercentageCell
                    {...props}
                    className="changePercentage"
                />
            ),
        },
        {
            field: "pop",
            sortable: false,
            visible: true,
            disableHeaderCellHover: true,
            headerComponent: DefaultCellHeaderRightAlign,
            displayName:
                granularity === BenchmarkGranularity.MONTHLY ? translate(textKeys.mom) : translate(textKeys.wow),
            width: "23%",
            sortDirection: "asc",
            isResizable: false,
            cellComponent: PercentPointCell,
        },
    ]);

const versusHoverContainerPopupConfig = {
    cssClassContainer: "Popup-element-wrapper-triangle",
    enabled: true,
    placement: "bottom",
    allowHover: true,
    width: 200,
};
